<div class='Notifications-container'>

  <h2> Le tue notifiche </h2>

  <app-notifications-widget
    [configuration]='notificationsWidgetConfiguration'></app-notifications-widget>

</div>
